var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button',_vm._g({staticClass:"dark-button",class:{ 'disabled-focus': _vm.disabledFocus },attrs:{"type":"primary"}},_vm.$listeners),[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }